// Dashboard.jsx
import { useState } from "react";
import Sidebar from "../Component/Sidebar";
import Header from "../../AdminPanel/Component/Header";
import LoadingOverlay from 'react-loading-overlay';

export default function Dashboard({ children, userDetails, logout, switchToSelf, loading }) {
  const [collapsed, setCollapsed] = useState(true); // ✅ collapsed by default

  return (
    <LoadingOverlay
      active={loading}
      spinner
      text='Loading...'
      className="loader"
    >

      <div className="flex h-screen bg-gray-50 overflow-hidden">
        {/* Sidebar */}
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} switchToSelf={switchToSelf} />

        {/* Right section */}
        <div
          className={`flex flex-col flex-1 transition-all duration-300
        ${(collapsed ? "ml-20" : "ml-64")}`}
        >
          <Header collapsed={collapsed} userDetails={userDetails} logout={logout} />

          <main className="flex-1 overflow-y-auto mt-20 bg-white">
            {children}
          </main>
        </div>
      </div>
    </LoadingOverlay >
  );
}
